// js
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UsageHeaderNav from './UsageHeaderNav';
import { makeGetAreaUsageProgress } from '../../selectors/dsa/usageSelectors';
import { SectionHeader } from '@its-svp/svp-common-ui';


function UsageHeader({area, areas, dsa, activeAreaIds, progress, baseNavRoute}) {

  return (
    <div className='usage-header svp-common-ui'>
      {!area &&
        <SectionHeader
          title='Usage'
          description='How is the customer using Splunk today and what value have they realized from it&apos;s usage?'
          landing
        />
      }
      {!!area &&
        <div className='usage-header-nav'>
          <UsageHeaderNav
            area={area}
            areas={areas}
            dsa={dsa}
            activeAreaIds={activeAreaIds}
            baseNavRoute={baseNavRoute}
          />
          <SectionHeader
            title={`Usage: ${area.title}`}
            description={`${progress.current}/${progress.total} Sections Complete`}
          />
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state, props) => {
  const getAreaUsageProgress = makeGetAreaUsageProgress();
  return {
    progress: getAreaUsageProgress(state, props)
  };
};

UsageHeader.propTypes = {
  area: PropTypes.object,
  areas: PropTypes.array,
  dsa: PropTypes.object,
  progress: PropTypes.object,
  activeAreaIds: PropTypes.array,
  baseNavRoute: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(UsageHeader);



// WEBPACK FOOTER //
// ./src/components/usage/UsageHeader.js